export default `Advertising
Aerospace
Analytics
AI
Agriculture
Art
Automotive
B2B
Banking
Big Data
Biotech
Blockchain
Broadcasting
Business Development
Cannabis
Cloud Computing
Communications
Computer
Computer Vision
Consulting
Consumer
Construction
CRM
Cyber Security
Data Visualization
Delivery
Developer APIs
Developer Platform
Developer Tools
Digital Entertainment
Digital Media
Digital Marketing
Drones
E-Commerce
Education
EdTech
Electronics
Employment
Enterprise Software
Energy
Esports
Event Management
Fashion
Finance
FinTech
Fitness
Food and Beverage
Food Delivery
Gambling
Gaming
Genetics
Graphic Design
GreenTech
Geospatial
Health Care
Human Resources
Hardware
Hospitality 
Hotel
Home Services
Information Technology
Industrial
Innovation Management
Infrastructure
Insurance
Internet of Things
Janitorial Service
Jewelry
Journalism
Knowledge Management
Language Learning
Lead Generation
Legal
Leisure
Lending
Life Science
Lifestyle
Logistics
Machine Learning
Manufacturing
Marketing
Marketplace
Media and Entertainment
Medical
Messaging
Music
Nanotechnology 
National Security
Navigation
Network Security
News
Non Profit
Nutrition
Oil and Gas
Outsourcing
Open Source
Optical Communication
Organic Foods
Payments
Pharmaceuticals 
Photography
Printing
Product Design
Property Management
Public Relations
Publishing
Quality Assurance
Quantified Self
Quantum Computing
Real Estate
Renewable Energy
Restaurants
Retail
Robotics
SaaS
Search Engine
Security
SEO
Social Media
Social Media Marketing
Software
Sports
Telecommunications
Therapeutics 
Tourism
Trading Platform
Training
Transportation
Travel
Unified Communications
University
Usability Testing
UX Design
Venture Capital
Veterinary
Video
Video Streaming
Virtual Reality
VoIP
Web Design
Web Development
Web Hosting
Wholesale
Wine and Spirits`.split('\n');


// WEBPACK FOOTER //
// ./src/components/Auth/industries.js